"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toastContainerClassNames: function() {
        return toastContainerClassNames;
    },
    useToastContainerStyles_unstable: function() {
        return useToastContainerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toastContainerClassNames = {
    root: 'fui-ToastContainer',
    timer: 'fui-ToastContainer__timer'
};
const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r1qaza64", "r1e6dlul", [
    ".r1qaza64{box-sizing:border-box;margin-top:16px;min-height:44px;pointer-events:all;border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);--fui-toast-height:44px;}",
    ".r1qaza64[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}",
    ".r1e6dlul{box-sizing:border-box;margin-top:16px;min-height:44px;pointer-events:all;border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);--fui-toast-height:44px;}",
    ".r1e6dlul[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);outline-style:solid;outline-color:var(--colorStrokeFocus2);}"
]);
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    enter: {
        vin17d: "fayl5bc",
        m1gqa9: "f17oyct0",
        Bv12yb3: "fvv8lvk"
    },
    exit: {
        vin17d: "f1tk3cza",
        m1gqa9: "f1nx6yy9",
        Bv12yb3: "f9wuypy"
    }
}, {
    d: [
        ".fayl5bc{animation-duration:200ms,400ms;}",
        ".f17oyct0{animation-delay:0ms,200ms;}",
        ".fvv8lvk{animation-name:f1rp83na,f5j8bii;}",
        ".f1tk3cza{animation-duration:400ms,200ms;}",
        ".f1nx6yy9{animation-delay:0ms,400ms;}",
        ".f9wuypy{animation-name:fk0lfw7,f1n32sdh;}"
    ],
    k: [
        "@keyframes f1rp83na{from{max-height:0;opacity:0;margin-top:0;}to{margin-top:16px;opacity:0;max-height:var(--fui-toast-height);}}",
        "@keyframes f5j8bii{from{opacity:0;}to{opacity:1;}}",
        "@keyframes fk0lfw7{from{opacity:1;}to{opacity:0;}}",
        "@keyframes f1n32sdh{from{opacity:0;}to{opacity:0;margin-top:0;max-height:0;}}"
    ]
});
const useToastContainerStyles_unstable = (state)=>{
    const rootBaseClassName = useRootBaseClassName();
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(toastContainerClassNames.root, rootBaseClassName, state.visible ? styles.enter : styles.exit, state.root.className);
    return state;
}; //# sourceMappingURL=useToastContainerStyles.styles.js.map
